import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import AppBar from 'components/AppBar';
import FloatingButton from 'components/FloatingButton';
import Loader from 'components/Loader';
import { Desktop, Mobile } from 'components/Responsive';
import ScreenHeader from 'components/ScreenHeader';
import Search from 'components/Search';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { GetAllBillingCompanyResponse } from 'models/billingCompany';

import BillingCompanyItem from './components/BillingCompanyItem';
import BranchCompanyEmptyList from './components/BranchCompanyEmptyList';
import { List, Container } from './styles';

interface Props {
  billingCompanyTarget?: string;
  billingCompanyList: GetAllBillingCompanyResponse[];
  isLoading: boolean;
  isSaving: boolean;
  ruleSelected?: GetAllBillingCompanyResponse;
  onCloseSelectionScreen?: () => void;
  onConfirmSelection?: (billingCompany: GetAllBillingCompanyResponse) => void;
  onToggle?: (billingCompany: GetAllBillingCompanyResponse) => void;
}

const BillingCompanySelectList = ({ billingCompanyList, isLoading, onToggle, isSaving }: Props) => {
  const [showSearch, setShowSearch] = useState(false);
  const [billingCompanyResult, setRulesResult] = useState<GetAllBillingCompanyResponse[]>([]);
  const history = useHistory();
  const { t } = useStoreTranslation();
  const [savingId, setSavingId] = useState<string>();

  const handleSelection = (billingCompany: GetAllBillingCompanyResponse) => {
    history.push(`billingCompany/${billingCompany.id}`);
  };

  const handleOnSearch = (value: string) => {
    if (value) {
      setShowSearch(true);
      setRulesResult(
        billingCompanyList.filter((billingCompany) => billingCompany.id.toLowerCase() === value.toLowerCase()),
      );
    } else {
      setShowSearch(false);
    }
  };

  const renderList = () => (
    <>
      <Search show={billingCompanyList.length >= 10} onSearch={handleOnSearch} />

      <List>
        {(showSearch ? billingCompanyResult : billingCompanyList).map((billingCompany) => (
          <BillingCompanyItem
            key={`user-${billingCompany.id}`}
            billingCompany={billingCompany}
            onClick={() => handleSelection(billingCompany)}
            loading={isSaving && savingId === billingCompany.id}
            onToggle={() => {
              setSavingId(billingCompany.id);
              if (onToggle) onToggle(billingCompany);
            }}
          />
        ))}
      </List>
    </>
  );

  return (
    <>
      <Mobile>
        <AppBar goBack={() => history.push('/booking')}>
          <h5>{t('userMenu.billingCompanyTitle')}</h5>
        </AppBar>
      </Mobile>

      {isLoading ? (
        <Loader fullScreen />
      ) : (
        <>
          <Desktop>
            <ScreenHeader title={t('userMenu.billingCompanyTitle')} subtitle={t('userMenu.billingCompanyDetail')} />
          </Desktop>

          <Container hasList={billingCompanyList.length > 0}>
            {billingCompanyList && billingCompanyList.length > 0 ? renderList() : <BranchCompanyEmptyList />}
          </Container>
        </>
      )}
      <FloatingButton zIndex={2} onClick={() => history.push('/billingCompany')} className="target" />
    </>
  );
};

export default BillingCompanySelectList;
